export const isMobile = () => {
    return window.innerWidth < 720;
};

export const isTablet = () => {
    return window.innerWidth >= 720;
};
